import React, { useContext, useEffect, useState } from "react";
import { PrimaryMobile } from "../buttons/mobile/Primary";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { CreditUserContext } from "../../context/CreditUser/CreditUserContext";
import { Numeral } from "react-numeral";
import { FriendsViewContext } from "../../context/Disclosures/friends/friendsContext";
import { RewardsViewContext } from "../../context/Disclosures/rewards/rewardsContext";
import { IndexedDBService } from "../../services/indexedDbService";

const indexedDbService = new IndexedDBService();

export function InviteFriends() {

  const { updateFriendsView } = useContext(FriendsViewContext);

  const handleClick = () => {
    updateFriendsView({
      openDisclosure: true,
    });
  };

  return (
    <>
      <div className="flex md:justify-center gap-2 lg:block lg:p-4">
        <div className="md:hidden lg:block">
          <div>
            <span className="font-bold text-white">
              Invita a tus amigos a Galilea
            </span>
          </div>
          <div className="text-white text-sm">
            Por cada amigo que invites a unirse a Galilea podrás recibir 300
            puntos que te servirán para aumentar tu nivel y recibir beneficios
            en tus futuros créditos
          </div>
        </div>
        <div className="grid justify-items-center lg:pt-4">
          <a className="grid content-center" href="#" onClick={handleClick}>
            <PrimaryMobile icon={<ArrowRightIcon className="w-6 h-auto" />} />
          </a>
        </div>
      </div>
    </>
  );
}

export function AlertPaymentReminder({ creditInfo, due }) {
  return (
    <>
      <div className="flex md:justify-center gap-2 lg:block lg:p-4">
        <div className="md:hidden lg:block">
          <div>
            <span className="font-bold text-white">
              Tu fecha límite está a punto de vencerse
            </span>
          </div>
          <div className="text-white text-sm">
            La fecha límite del pago de tu crédito{" "}
            {(creditInfo?.credit_id ?? "").substring(0, 7)} se vence en{" "}
            {due ?? 0} días, paga ahora y recibe recompensas por pagar antes de
            tiempo
          </div>
        </div>
        <div className="grid justify-items-center lg:pt-4">
          <a className="grid content-center" href="/pagar">
            <PrimaryMobile icon={<ArrowRightIcon className="w-6 h-auto" />} />
          </a>
        </div>
      </div>
    </>
  );
}

export function AlertLimitDate({ creditInfo }) {
  return (
    <>
      <div className="flex md:justify-center gap-2 lg:block lg:p-4">
        <div className="md:hidden lg:block">
          <div>
            <span className="font-bold text-white">
              Tu fecha límite de pago es hoy
            </span>
          </div>
          <div className="text-white text-sm">
            La fecha límite del pago de tu crédito{" "}
            {(creditInfo?.credit_id ?? "").substring(0, 7)} se vence hoy, paga
            ahora y recibe recompensas por pagar a tiempo
          </div>
        </div>
        <div className="grid justify-items-center lg:pt-4">
          <a className="grid content-center" href="/pagar">
            <PrimaryMobile icon={<ArrowRightIcon className="w-6 h-auto" />} />
          </a>
        </div>
      </div>
    </>
  );
}

export function AlertCreditDefault({ creditInfo, due }) {
  return (
    <>
      <div className="flex md:justify-center gap-2 lg:block lg:p-4">
        <div className="md:hidden lg:block">
          <div>
            <span className="font-bold text-white">
              Tu crédito presenta mora
            </span>
          </div>
          <div className="text-white text-sm">
            Tu crédito {(creditInfo?.credit_id ?? "").substring(0, 7)} presenta{" "}
            {due * -1} días en mora, paga ahora y evita reportes negativos en
            centrales de riesgo
          </div>
        </div>
        <div className="grid justify-items-center lg:pt-4">
          <a className="grid content-center" href="/pagar">
            <PrimaryMobile icon={<ArrowRightIcon className="w-6 h-auto" />} />
          </a>
        </div>
      </div>
    </>
  );
}

export function AlertQuotaAvailable() {
  const [approvedQuota, setApprovedQuota] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);

  const handleFindQuotaInfo = async () => {
    try {
      let id = 'quota';
      let item = await indexedDbService.findItem('id', id);
      if (item) {
        setApprovedQuota(item?.quotaInfo?.cupoAprobado);
      }
    } catch (error) {
      console.log(error);
    }finally {
      setDataLoaded(true);
    }
  }

  useEffect(() => {
    handleFindQuotaInfo();
  }, []);


  return (
    <>
      <div className="flex md:justify-center gap-2 lg:block lg:p-4">
        <div className="md:hidden lg:block">
          <div>
            <span className="font-bold text-white">
              Tu cupo de crédito está disponible
            </span>
          </div>
          <div className="text-white text-sm">
            Tienes un cupo disponible por valor de {
              dataLoaded === true ? (
                <Numeral
                  className="text-md font-bold"
                  format={"$0,0"}
                  value={approvedQuota}
                />
              ) : (
                'Cargando...' // Mostrar algo mientras se obtiene el valor
              )
            } y está listo
            para ser desembolsado a tu cuenta bancaria
          </div>
        </div>
        <div className="grid justify-items-center lg:pt-4">
          <a className="grid content-center" href="/renovar">
            <PrimaryMobile icon={<ArrowRightIcon className="w-6 h-auto" />} />
          </a>
        </div>
      </div>
    </>
  );
}

export function RewardAvailable() {
  const { updateRewardsView } = useContext(RewardsViewContext);

  const handleClick = () => {
    updateRewardsView({
      openDisclosure: true,
      openDisclosureMyRewards: true
    });
  };

  return (
    <>
      <div className="flex md:justify-center gap-2 lg:block lg:p-4">
        <div className="md:hidden lg:block">
          <div>
            <span className="font-bold text-white">
              Tienes recompensas pendientes de reclamar
            </span>
          </div>
          <div className="text-white text-sm">
            Has alcanzado un nuevo nivel! Reclama tu recompensa ahora y disfruta de tus beneficios en Galilea
          </div>
        </div>
        <div className="grid justify-items-center lg:pt-4">
          <a className="grid content-center" href="#" onClick={handleClick}>
            <PrimaryMobile icon={<ArrowRightIcon className="w-6 h-auto" />} />
          </a>
        </div>
      </div>
    </>
  );
}
